import React, { useEffect } from "react";
import closeIcon from "@public/img/close.svg";
import "@/styles/player-shortcuts-dialog.css";

type ShortcutRow = {
  action: string;
  keys: string;
};

var SHORTCUT_ROWS: ShortcutRow[] = [
  { action: "پخش یا توقف", keys: "Space, K, Enter" },
  { action: "۵ ثانیه عقب / جلو", keys: "Left / Right, , / ." },
  { action: "۳۰ ثانیه عقب / جلو", keys: "Shift + Left / Right" },
  { action: "۱۰ ثانیه عقب / جلو", keys: "J / L" },
  { action: "ابتدا / نزدیک پایان", keys: "Home / End" },
  { action: "پرش درصدی", keys: "0 … 9" },
  { action: "صدا", keys: "Up / Down, M" },
  { action: "سرعت پخش", keys: "Shift + , / ." },
  { action: "تمام‌صفحه", keys: "F, Esc" },
  { action: "تصویر در تصویر", keys: "P, I" },
  { action: "نسبت تصویر", keys: "A" },
  { action: "زیرنویس بعدی", keys: "C" },
  { action: "کیفیت پایین‌تر / بالاتر", keys: "[ / ]" },
  { action: "قفل کنترل‌ها", keys: "Q" },
  { action: "بازگشت", keys: "B" },
];

type PlayerShortcutsDialogProps = {
  onClose: () => void;
};

export default function PlayerShortcutsDialog(props: PlayerShortcutsDialogProps) {
  var onClose = props.onClose;

  useEffect(
    function () {
      var onKey = function (e: KeyboardEvent) {
        if (e.key === "Escape" || e.keyCode === 27) {
          onClose();
        }
      };
      window.addEventListener("keydown", onKey);
      return function () {
        window.removeEventListener("keydown", onKey);
      };
    },
    [onClose]
  );

  return (
    <div
      className="player-shortcuts-dialog"
      data-player-shortcuts-dialog=""
      data-player-ignore-toggle=""
      onClick={onClose}
    >
      <div className="player-shortcuts-dialog__wrap">
        <div className="player-shortcuts-dialog__center">
          <div
            className="player-shortcuts-dialog__card"
            dir="rtl"
            onClick={function (e) {
              e.stopPropagation();
            }}
          >
            <div className="player-shortcuts-dialog__header">
              <div className="player-shortcuts-dialog__header-cell">
                <h3 className="player-shortcuts-dialog__title">میانبرهای کیبورد</h3>
              </div>
              <div className="player-shortcuts-dialog__header-cell player-shortcuts-dialog__header-cell--close">
                <button
                  type="button"
                  className="player-shortcuts-dialog__close"
                  aria-label="بستن"
                  onClick={onClose}
                >
                  <img src={closeIcon} alt="" width={24} height={24} />
                </button>
              </div>
            </div>
            <table className="player-shortcuts-dialog__table">
              <tbody>
                {SHORTCUT_ROWS.map(function (row) {
                  return (
                    <tr key={row.action}>
                      <td>{row.action}</td>
                      <td className="player-shortcuts-dialog__keys">{row.keys}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
